export const CONFIG_CONSTS = {
  moduleName: 'epb-config',

  getters: {
    instances: 'instances',
    currentInstance: 'currentInstance',
    kpis: 'kpis'
  },
  actions: {
    loadInstances: 'loadInstances',
    clearModule: 'clearModule'
  },
  mutations: {
    setInstances: 'setInstances',
    clearModule: 'clearModule'
  }

};
